/**
 * SVG-глифы и цвета маркеров вьюера (Aurora): категории POI + инфраструктура
 * графа. Глифы портированы из редактора «Territory CAD» (b2b icons.ts) —
 * одна визуальная семья на весь продукт. Цвета — auroraCategory (@app/tokens),
 * недостающие типы дополнены здесь. Грузится лениво вместе с картой.
 */
import { auroraCategory } from '@app/tokens'
import { categoryIcon } from '../categories'

const S = (body: string): string =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`

const GLYPHS: Record<string, string> = {
  shop: S(
    '<path d="M3 9h18l-1.4 10.2a2 2 0 0 1-2 1.8H6.4a2 2 0 0 1-2-1.8z"/><path d="M8 9V6.5a4 4 0 0 1 8 0V9"/>',
  ),
  warehouse: S('<path d="M3 21V9l9-5 9 5v12"/><path d="M8 21v-7h8v7"/>'),
  office: S(
    '<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M9 8h2M13 8h2M9 12h2M13 12h2M9 16h6"/>',
  ),
  cafe: S(
    '<path d="M4 9h13v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z"/><path d="M17 10h2a2.5 2.5 0 0 1 0 5h-2"/><path d="M7 3v3M11 3v3"/>',
  ),
  auto: S(
    '<path d="M5 17h14"/><path d="M6 17v2M18 17v2"/><path d="M4 13l1.6-4.4A2 2 0 0 1 7.5 7h9a2 2 0 0 1 1.9 1.6L20 13v4H4z"/><circle cx="8" cy="14.5" r="1"/><circle cx="16" cy="14.5" r="1"/>',
  ),
  factory: S('<path d="M3 20h18V9l-6 4V9l-6 4V4H3z"/>'),
  parking: S(
    '<rect x="3" y="3" width="18" height="18" rx="3"/><path d="M9 17V7h4a3 3 0 0 1 0 6H9"/>',
  ),
  checkpoint: S('<path d="M4 4v16"/><path d="M4 8h16l-2.5 3.5L20 15H4"/>'),
  shelter: S(
    '<path d="M12 3 5 6v5c0 4.5 2.7 7.4 7 9 4.3-1.6 7-4.5 7-9V6l-7-3z"/><path d="M9 11.5l2 2 4-4.5"/>',
  ),
  dock: S(
    '<path d="M2 19h20"/><path d="M3 19 16 7"/><rect x="14" y="5" width="7" height="7" rx="1"/>',
  ),
  entrance: S(
    '<path d="M3 21h18"/><path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17"/><circle cx="14.5" cy="12" r="1"/>',
  ),
  elevator: S(
    '<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M12 3v18"/><path d="M8.5 9.5 7 8l-1.5 1.5"/><path d="M16.5 14.5 18 16l1.5-1.5"/>',
  ),
  stairs: S('<path d="M3 20h4v-4h4v-4h4V8h4V4"/><path d="M3 20h18"/>'),
  escalator: S('<path d="M4 18 18 4"/><path d="M14 4h6v6"/><circle cx="6.5" cy="18.5" r="1.5"/>'),
  qr: S(
    '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3z"/><path d="M20 14v3"/><path d="M17 20h4"/>',
  ),
  info: S('<circle cx="12" cy="12" r="9"/><path d="M12 8h.01"/><path d="M11 12h1v4h1"/>'),
  wc: S(
    '<circle cx="7.5" cy="5" r="1.5"/><path d="M7.5 8v5"/><path d="M5 21l2.5-8L10 21"/><circle cx="16.5" cy="5" r="1.5"/><path d="M16.5 8v13"/><path d="M13.5 12h6"/>',
  ),
  bench: S('<path d="M4 10h16v3H4z"/><path d="M6 13v6M18 13v6"/><path d="M4 10V7h16v3"/>'),
  plant: S(
    '<path d="M12 21v-8"/><path d="M12 13c0-4 3-7 7-7 0 4-3 7-7 7z"/><path d="M12 13c0-3-2.5-5-5.5-5 0 3 2.5 5 5.5 5z"/>',
  ),
  sign: S('<path d="M12 21V8"/><path d="M5 4h11l3 2.5L16 9H5z"/>'),
  truck_scale: S(
    '<path d="M3 21h18"/><rect x="5" y="15" width="14" height="4" rx="1"/><path d="M12 15V8"/><path d="M7 8h10l-1.5-3h-7z"/>',
  ),
  atm: S(
    '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18"/><path d="M7 15h4"/>',
  ),
  ev_charger: S(
    '<rect x="5" y="3" width="10" height="18" rx="2"/><path d="M10 7l-2 4h4l-2 4"/><path d="M15 8h3v8a2 2 0 0 1-4 0"/>',
  ),
  pin: S(
    '<path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  ),
}

/** Синонимы категорий RVF → базовый глиф. */
const ALIASES: Record<string, string> = {
  loading_dock: 'dock',
  ramp: 'dock',
  door: 'entrance',
  gate: 'checkpoint',
  production: 'factory',
  auto_service: 'auto',
  retail: 'shop',
  cafe_restaurant: 'cafe',
}

/** Цвета типов, которых нет в auroraCategory (тон Aurora, см. tokens). */
const EXTRA_COLORS: Record<string, string> = {
  atm: '#e57bba',
  ev_charger: '#53be70',
  elevator: '#7e8ef4',
  stairs: '#3ba6f5',
  escalator: '#00beaf',
  truck_scale: '#fcab00',
  bench: '#7b8891',
  plant: '#53be70',
  sign: '#7b8891',
  door: '#00c0a0',
  gate: '#f3625d',
  auto_service: '#ea6a64',
  production: '#b57bdd',
}

/** Имена глифов набора — из них админ выбирает значок категории (01.08). */
export const GLYPH_NAMES: readonly string[] = Object.keys(GLYPHS).sort()

export interface MarkerVisual {
  readonly svg: string
  readonly color: string
}

/** Глиф+цвет для категории POI или типа узла графа; неизвестное — пин. */
export function markerVisual(kind: string): MarkerVisual {
  // Значок, назначенный админом справочнику категорий (01.08), важнее
  // встроенного соответствия — иначе выбор в кабинете ни на что не влияет.
  const chosen = categoryIcon(kind)
  const base = chosen && GLYPHS[chosen] ? chosen : GLYPHS[kind] ? kind : (ALIASES[kind] ?? 'pin')
  const cat = auroraCategory as Record<string, string>
  const color =
    cat[kind] ??
    EXTRA_COLORS[kind] ??
    cat[base] ??
    EXTRA_COLORS[base] ??
    cat['__default'] ??
    '#7b8891'
  return { svg: GLYPHS[base] ?? (GLYPHS['pin'] as string), color }
}
